exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-container .slidedown,.select-container .slideup{max-height:0;overflow-y:hidden;-webkit-transition:max-height .3s ease-in-out;transition:max-height .3s ease-in-out}.select-container .slidedown{max-height:140px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-efc13c2c","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/CustomSelect.vue
// module id = ysbV
// module chunks = 0